"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Price = ({
  prefix,
  decimalSign,
  subscriptLabel,
  integerValue,
  decimalValue,
  size,
  fixedSize,
  currencyLabel,
  caption,
  currencyPosition,
  regularFontWeight,
  strikeoutPrice,
  bti,
  subtle,
  className,
  ...other
}) => {
  const baseClass = `${prefix}price`;
  const classes = (0, _classnames.default)(baseClass, currencyPosition === 'leading' && `${baseClass}--leading`, currencyPosition === 'trailing' && `${baseClass}--trailing`, !strikeoutPrice && fixedSize && `${baseClass}--fixed-size`, currencyPosition && `${baseClass}--${currencyPosition}`, size && `${baseClass}--${size}`, subtle && `${baseClass}--subtle`, strikeoutPrice && `${baseClass}--strikeout`, !bti && regularFontWeight && `${baseClass}--regular-font-weight`, bti && `${baseClass}--bti-price`, className);
  let PriceElement = 'span';

  if (bti) {
    PriceElement = 'em';
  }

  let negativeSign = null;

  if (integerValue[0] === '−' || integerValue[0] === '-') {
    negativeSign = '−\u00A0';
  }

  const ariaIntegerValue = integerValue.replace(/\s|\.|,/g, '');
  const ariaLabel = [caption, negativeSign, currencyPosition === 'leading' ? currencyLabel : '', [negativeSign ? ariaIntegerValue.slice(1) : ariaIntegerValue, decimalSign, decimalValue, currencyPosition === 'trailing' ? currencyLabel : '', subscriptLabel].filter(e => !!e).join('')].filter(e => !!e).join(' ');
  return _react.default.createElement(PriceElement, _extends({
    className: classes
  }, other, {
    "aria-label": ariaLabel
  }), negativeSign && _react.default.createElement("span", {
    className: `${baseClass}__minus`
  }, negativeSign), currencyPosition === 'leading' && _react.default.createElement("span", {
    className: `${baseClass}__currency`
  }, currencyLabel), _react.default.createElement("span", {
    className: `${baseClass}__integer`
  }, negativeSign ? integerValue.slice(1) : integerValue), (decimalValue || currencyPosition === 'trailing') && _react.default.createElement("span", {
    className: `${baseClass}__decimal`
  }, decimalSign && _react.default.createElement("span", {
    className: `${baseClass}__separator`
  }, decimalSign), decimalValue && decimalValue.trim()), currencyPosition === 'trailing' && _react.default.createElement("span", {
    className: `${baseClass}__currency`
  }, currencyLabel), subscriptLabel && _react.default.createElement("span", {
    className: `${baseClass}__subscript`
  }, subscriptLabel));
};

Price.defaultProps = {
  prefix: '',
  size: 'medium',
  currencyPosition: 'leading'
};
var _default = Price;
exports.default = _default;